/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUsagePlanRequest } from '../../models/update-usage-plan-request';
import { UsagePlanResponse } from '../../models/usage-plan-response';

export interface PutUsagePlan$Params {
  'Active-Tenant-Identifier': string;
      body: UpdateUsagePlanRequest
}

export function putUsagePlan(http: HttpClient, rootUrl: string, params: PutUsagePlan$Params, context?: HttpContext): Observable<StrictHttpResponse<UsagePlanResponse>> {
  const rb = new RequestBuilder(rootUrl, putUsagePlan.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsagePlanResponse>;
    })
  );
}

putUsagePlan.PATH = '/usage-plan';
